import React from 'react'
import { useParams } from 'react-router-dom'
import { DataResources } from './constent'
const ResourcesDetails = () => {
    const { name } = useParams();

 // Find resource by id
 const resource = DataResources?.find(item => item.name === name);
console.log(resource , "resource");

 if (!resource) {
   return <div className="container py-5"><h2>Resource not found!</h2></div>
 }

 return (
   <div className="container py-5 mt-5">
    <div className="mt-5">
    <img className='w-100 mb-4' src={resource?.img} />
     <h2 className='mb-4'>{resource.heading}</h2>
     {resource.content.map((para, index) => (
       <p className='mb-3' key={index} dangerouslySetInnerHTML={{ __html: para }}></p>
     ))}
   </div></div>
 )
}

export default ResourcesDetails